import { Box, Card } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { AdminEmployeeService } from '../service';
import EmployeePreviewHeader from './components/EmployeePreviewHeader';
import EmployeePreviewLeftCard from './components/EmployeePreviewLeftCard';
import EmployeePreviewRightCard from './components/EmployeePreviewRightCard';

const EmployeePreview = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('myProfile');
  const [user, setUser] = useState<IUser | null>(null);

  useEffect(() => {
    if (id) {
      AdminEmployeeService.getPreview(Number(id))
        .then((response) => {
          setUser(response);
        })
        .catch(handleError);
    }
  }, [id]);
  return (
    <>
      {user?.id && (
        <Card>
          <Box
            sx={{
              paddingBottom: '20px',
            }}
          >
            <EmployeePreviewHeader user={user} />
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  md: 3,
                }}
              >
                <EmployeePreviewLeftCard
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 9,
                }}
              >
                <EmployeePreviewRightCard user={user} activeTab={activeTab} />
              </Grid>
            </Grid>
          </Box>
        </Card>
      )}
    </>
  );
};

export default EmployeePreview;
